export default [
  {
    path: '/door-plate-equipment',
    name: 'DoorPlateEquipment',
    component: resolve => require(['@/views/DoorPlateEquipment'], resolve)
  }
]
